import { useMemo } from "react";

import { useAuthStore } from "@nasam/kernel";

// A stable reference — a fresh `[]` literal in the selector would make
// zustand see a new value on every render (no session) and loop forever.
const NO_PERMISSIONS: readonly string[] = [];

/**
 * The contract enforces "every expression must be a permission the caller
 * personally holds" server-side, so the grantable set is exactly the session
 * user's own `permissions[]` — there is no separate endpoint to query it from.
 * Shared (not roles-only): any feature whose create/edit form embeds
 * `PermissionMatrix` -- e.g. operational users, seeding a user's permissions
 * from a chosen role -- needs this same grantable set.
 */
export function useGrantablePermissions(): ReadonlySet<string> {
  const permissions = useAuthStore(
    (state) => state.user?.permissions ?? NO_PERMISSIONS,
  );
  return useMemo(() => new Set(permissions), [permissions]);
}
